import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const columns = [
  {
    title: "内容导航",
    links: [
      { label: "影视作品", path: "/works" },
      { label: "明星资讯", path: "/news" },
      { label: "关于本站", path: "/about" },
      { label: "搜索", path: "/search" },
    ],
  },
  {
    title: "热门作品",
    links: [
      { label: "《无声的证词》", path: "/works/silent-witness" },
      { label: "《春山旧梦》", path: "/works/palace-of-spring" },
      { label: "《春日来信》", path: "/works/spring-letter" },
      { label: "《北行列车》", path: "/works/northbound" },
    ],
  },
  {
    title: "最新资讯",
    links: [
      { label: "《雨停之后》定档", path: "/news/premiere-after-rain" },
      { label: "专访天海翼", path: "/news/interview-2025" },
      { label: "影迷见面会回顾", path: "/news/activity-fanmeeting" },
      { label: "《北行列车》入围", path: "/news/award-northbound" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-foreground-950">
                翼
              </span>
              <span className="font-heading text-lg font-bold tracking-wide">{siteInfo.brand}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-100/80">{siteInfo.tagline}</p>
            <p className="mt-4 flex items-center gap-2 text-sm text-primary-100/70">
              <i className="ri-mail-line" />
              <a href={`mailto:${siteInfo.email}`} className="cursor-pointer hover:text-background-50">
                {siteInfo.email}
              </a>
            </p>
            <p className="mt-2 flex items-center gap-2 text-sm text-primary-100/70">
              <i className="ri-map-pin-line" />
              {siteInfo.location}
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="mb-4 font-heading text-sm font-semibold text-accent-400">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="cursor-pointer text-sm text-primary-100/75 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {siteInfo.established} {siteInfo.brand} · 本站为影视资讯演示站点，内容仅供参考</p>
          <p>本站不含任何播放、下载或会员功能，所有资料仅供影迷了解作品使用</p>
        </div>
      </div>
    </footer>
  );
}